import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    const go = () => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
    go();
    setTimeout(go, 600);
    setTimeout(go, 1200);
  };
  return <section className="pb-6 md:pb-12 px-4 bg-white" data-id="element-127">
      <div className="bg-white border-b border-gray-100 py-2 md:py-4 mb-6 md:mb-10 text-center" data-id="element-128">
        <span className="text-base md:text-xl font-black text-gray-900 tracking-wide" data-id="element-129">
          ⭐ Loved by 12,000+ Families Worldwide • Perfect for Ages 3 to 12+
          (Progressive Difficulty)
        </span>
      </div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-130">
        <h1 className="text-2xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-131">
          Your Child Doesn't Have An Attention Problem. Their Brain Just Hasn't
          Been Trained Yet.
        </h1>

        <button onClick={scrollToPricing} className="w-full max-w-3xl mx-auto block cursor-pointer md:hover:scale-[1.02] md:transition-transform md:duration-300" data-id="element-132">
          <img src="https://cdn.magicpatterns.com/uploads/vN4PmtBaiFEccxLMF1kWvR/ChatGPT_Image_25_jun_2026,_15_41_14.webp" alt="Little Genius System — Complete 310-page brain development system for kids ages 4-10, including 6 workbooks and 5 bonus books" className="w-full h-auto md:drop-shadow-2xl mb-5 md:mb-8 rounded-xl" fetchPriority="high" decoding="auto" loading="eager" sizes="(max-width: 768px) 100vw, 768px" width={1536} height={1024} style={{
          aspectRatio: '3/2',
          objectFit: 'contain'
        }} data-id="element-133" />
        </button>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 p-3 md:p-4 mb-5 md:mb-8 text-left md:text-center" data-id="element-134">
          <p className="text-sm md:text-xl font-medium text-gray-800" data-id="element-135">
            The only complete brain development system inspired by cognitive
            science and Montessori principles that builds attention, memory,
            logic, emotional control and creativity — in just 10 minutes a day.
            No screens. No struggle. No boredom.
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-136">
          <CTAButton text="✨ YES, I WANT THE SYSTEM NOW" subtext="📄 100% Digital • ⚡ Instant Access • 🛡️ 7-Day Guarantee" size="sm" data-id="element-137" />
        </div>
      </div>
    </section>;
}